import { createI18n } from 'vue-i18n'
import zh from './zh'
import en from './en'
import es from './es'
import hi from './hi'
import bn from './bn'
import pt from './pt'
import ru from './ru'
import ja from './ja'
import ms from './ms'
import ar from './ar'
import az from './az'

const messages = {
  zh,
  en,
  es,
  hi,
  bn,
  pt,
  ru,
  ja,
  ms,
  ar,
  az,
}

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'en',
  fallbackLocale: 'en',
  messages,
  globalInjection: true,
})

export default i18n
